import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ModalWindowTypes } from '../utils/@globalTypes';
import { PageSelectors, setModalWindowData } from '../redux/reducers/pageSlice';
import CreatingMainObjectWindow from '../components/ModalWindow/CreatingMainObjectWindow';
import ActivateAccountWindow from '../components/ModalWindow/ActivateAccountWindow';
import CreatingRentalObjectWindow from '../components/ModalWindow/CreatingRentalObjectWindow';
import ShowReservationWindow from '../components/ModalWindow/ShowReservationWindow';
import CreatingReservationWindow from '../components/ModalWindow/CreatingReservationWindow';
import TariffActivationWindow from '../components/ModalWindow/TariffActivation';
import TariffWarningWindow from '../components/ModalWindow/TariffWarning';
import NewServiceTimeWindow from '../components/ModalWindow/NewServiceTimeWindow';
import ShowServiceTimeWindow from '../components/ModalWindow/ShowServiceTimeWindow';
import CreatingObjectContacts from '../components/ModalWindow/CreatingObjectContacts';
import ShowFeaturesWindow from '../components/ModalWindow/ShowFeaturesWindow';
import ExternalBookingWindow from '../components/ModalWindow/ExternalBookingWindow/ExternalBookingWindow';
import { withModalSearchParams, withoutModalSearchParams } from '../utils/bookingModalSearchParams';

const ModalWindowProvider = () => {
  const dispatch = useDispatch();

  const modalWindowType = useSelector(PageSelectors.getModalWindowData('type'));
  const modalWindowData = useSelector(PageSelectors.getModalWindowData('data'));

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const currentModalWindowType = searchParams.get('popup');

    if (modalWindowType) {
      if (modalWindowType !== ModalWindowTypes.CLOSE) {
        let bookingId: number | undefined;
        if (modalWindowType === ModalWindowTypes.SHOW_EXTERNAL_RESERVATION) {
          bookingId = (modalWindowData as { id?: number } | null)?.id;
        }
        const nextParams = withModalSearchParams(searchParams, modalWindowType, bookingId);
        setSearchParams(nextParams);
        dispatch(setModalWindowData({ type: null, data: modalWindowData }));
      } else if (
        modalWindowType === ModalWindowTypes.CLOSE &&
        currentModalWindowType
      ) {
        setSearchParams(withoutModalSearchParams(searchParams));
      }
    }
  }, [modalWindowType, searchParams, modalWindowData]);

  switch (searchParams.get('popup')) {
    case ModalWindowTypes.CREATE_MAIN_OBJECT:
      return <CreatingMainObjectWindow />;
    case ModalWindowTypes.ACTIVATE_ACCOUNT:
      return <ActivateAccountWindow />;
    case ModalWindowTypes.CREATE_RENTAL_OBJECT:
      return <CreatingRentalObjectWindow />;
    case ModalWindowTypes.CREATE_RESERVATION:
      return <CreatingReservationWindow />;
    case ModalWindowTypes.SHOW_RESERVATION:
      return <ShowReservationWindow data={modalWindowData} />;
    case ModalWindowTypes.SHOW_EXTERNAL_RESERVATION: {
      const bookingId = Number(searchParams.get('bookingId'));
      return bookingId > 0 ? <ExternalBookingWindow bookingId={bookingId} /> : null;
    }
    case ModalWindowTypes.TARIFF_ACTIVATION:
      return <TariffActivationWindow data={modalWindowData} />;
    case ModalWindowTypes.TARIFF_WARNING:
      return <TariffWarningWindow data={modalWindowData} />;
    case ModalWindowTypes.NEW_OBJECT_CLOSURE:
      return <NewServiceTimeWindow />;
    case ModalWindowTypes.SHOW_OBJECT_CLOSURE:
      return <ShowServiceTimeWindow data={modalWindowData} />;
    case ModalWindowTypes.CREATE_OBJECT_CONTACTS:
      return <CreatingObjectContacts />;
    case ModalWindowTypes.SHOW_FEATURES:
      return <ShowFeaturesWindow data={modalWindowData} />;
    default:
      return null;
  }
};

export default ModalWindowProvider;
